export default __webpack_public_path__ + "static/media/slide3.ea32b5ab.webp";